// src/services/paymentService.ts
import api from "../api/axiosClient";

const BASE = "/Payment";

export const getPaymentsByBooking = async (bookingId: number) => {
  const res = await api.get(`${BASE}/booking/${bookingId}`);
  return res.data;
};

export const createPayment = async (data: any) => {
  const res = await api.post(BASE, data);
  return res.data;
};

export const updatePayment = async (id: number, data: any) => {
  const res = await api.put(`${BASE}/${id}`, data);
  return res.data;
};

export const deletePayment = async (id: number) => {
  const res = await api.delete(`${BASE}/${id}`);
  return res.data;
};
